{
  "activate_for_visible": "Активируйте, чтобы сделать страницу видимой в интернете",
  "activate_to_publish": "Активируйте, чтобы показать эту вакансию на карьерной странице",
  "auto_reply_enabled_description": "Автоматически отправлять кандидатам письмо при отклике",
  "auto_reply_enabled_title": "Отправлять письмо-подтверждение",
  "auto_reply_title": "Подтверждение отклика",
  "background_color": "Цвет фона",
  "button_color": "Цвет кнопок",
  "career_page": "Сайт вакансии",
  "choose_page": "Выберите страницу",
  "confirmation_delete": "Вы хотите удалить эту карьерную страницу?",
  "create_modal_title": "Создать новую карьерную страницу",
  "create_page": "Создать страницу",
  "optional_short_description": "Необязательное краткое описание политики вашей компании в сфере HR и её ценностей",
  "page_deleted": "Страница удалена",
  "page_title": "Заголовок страницы",
  "publish_on_career_page": "Опубликовать на карьерной странице",
  "sub_header": "Подзаголовок",
  "update_modal_title": "Редактировать карьерную страницу",
  "update_page": "Обновить страницу",
  "~": "~"
}
